import { UiKit } from '@datavant/idsb-shared/uikit';
import React, { CSSProperties } from 'react';

export const DebugRadioGroup = (props: {
    onValueSelected: (newValue: string) => void;
    value: string;
    options: readonly string[];
}): JSX.Element => {
    return (
        <UiKit.Chakra.RadioGroup
            onChange={props.onValueSelected}
            color={UiKit.consistency.gray90}
            value={props.value}
        >
            <UiKit.Chakra.HStack spacing={UiKit.consistency.buffer} justifyContent={'flex-end'}>
                {props.options.map(option => {
                    const style: CSSProperties = {
                        textTransform: 'capitalize',
                    };
                    const capitalized = <span style={style}>{option}</span>;
                    return (
                        <UiKit.Chakra.Radio key={`option-${option}`} value={option}>
                            {capitalized}
                        </UiKit.Chakra.Radio>
                    );
                })}
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.RadioGroup>
    );
};
